import styled from 'styled-components';
import NavigationTab from '../detail/components/summary/NavigationTab';
import Footer from '../components/footer/Footer';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { MainPageTop } from '../components/pageTop/PageTop';
import { isLogin } from '../../utils/auth';
import Menu from '../components/menu/Menu';

function FreeTrial() {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);

  const videoList = [
    {
      text: `국내 최초 부동산 퀀트\n경공매 사이트 땅집고옥션`,
      url: 'https://drive.google.com/file/d/1VrmVHqMorU5WdLd1vvfmB7ZnXvOq2qWH/preview',
    },
    {
      text: `딱 3단계만 알면\nAI 알고리즘 설계 끝!`,
      url: 'https://www.youtube.com/embed/2K1QcDpFdxo',
    },
  ];

  const handleCopyAddress = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        alert('URL이 복사되었습니다!');
      })
      .catch((err) => {
        console.error('URL 복사에 실패했습니다:', err);
        alert('URL 복사에 실패했습니다.');
      });
  };

  return (
    <Container>
      <MainPageTop setOpenMenu={setOpenMenu} menu={true} />
      <Confirm_Button2
        disabled={isLogin()}
        onClick={() => {
          if (!isLogin()) {
            navigate('/login');
          }
        }}
      >
        {isLogin() ? '현재 5일 무료 체험 중입니다.' : `5일 0원 체험하러가기 >`}
      </Confirm_Button2>

      <TopBar>
        <TopBar_Inner>
          <img
            src="/assets/images/promotion/free/Logo3.svg"
            alt=""
            style={{ width: '45px', height: '24px' }}
            onClick={() => navigate('/')}
          />
          <img
            src="/assets/images/promotion/free/Share.svg"
            width={34}
            height={34}
            alt=""
            style={{ marginRight: '-8px' }}
            onClick={handleCopyAddress}
          />
        </TopBar_Inner>
      </TopBar>

      <Content paddingTop={24} paddingBottom={50}>
        <Inner gap={22}>
          <TitleBadge>신규 회원가입 감사 이벤트</TitleBadge>
          <img
            src="/assets/images/promotion/free/freeTrial.png"
            alt=""
            width={328}
            height={197}
          />
          <TitleDescription>
            <p>지금 바로 5일동안</p>
            <p>
              <span>경공매 검색</span>부터 <span>퀀트 투자</span>까지
            </p>
            <p>무료로 체험해보세요</p>
          </TitleDescription>
        </Inner>
      </Content>

      <Content backgroundColor="#DFE0E5" paddingTop={64} paddingBottom={64}>
        <Inner gap={40}>
          <Inner gap={8}>
            <Text Paperlogy weight={400} size={18} height={100}>
              가입만하면 누구나!
            </Text>
            <Text Paperlogy weight={700} size={18} height={100}>
              땅집고옥션
            </Text>
            <Badge>5일 무료체험</Badge>
          </Inner>

          {videoList.map(({ text, url }, idx) => (
            <Inner gap={16} key={url}>
              <Text
                weight={500}
                size={16}
                style={{ textAlign: 'center', whiteSpace: 'pre-line' }}
              >
                {text}
              </Text>
              {idx === 0 ? (
                <video
                  width="328"
                  height="185"
                  controls
                  style={{ borderRadius: '16px' }}
                  poster="/assets/images/promotion/free/video_thumbnail.PNG"
                >
                  <source
                    src="/assets/images/promotion/free/introduce_zipgoai.mp4"
                    type="video/mp4"
                  />
                  브라우저가 video 태그를 지원하지 않습니다.
                </video>
              ) : (
                <iframe
                  src="https://www.youtube.com/embed/2K1QcDpFdxo"
                  width={328}
                  height={185}
                  style={{ borderRadius: '16px' }}
                />
              )}
              {/* <iframe
                src={url}
                title={text}
                width={328}
                height={185}
                style={{
                  borderRadius: '16px',
                }}
              /> */}
            </Inner>
          ))}
        </Inner>
      </Content>

      <Content
        backgroundColor="#122227"
        paddingTop={64}
        paddingBottom={64}
        paddingRL={20}
      >
        <Inner gap={40}>
          <Text
            Paperlogy
            weight={700}
            size={18}
            color="#FFFFFF"
            style={{ textAlign: 'center' }}
          >
            땅집고옥션 가입만 하면
            <br />
            이벤트 기간 동안 <Highlight>모든 서비스 무료</Highlight>
          </Text>
          <Column gap={40}>
            <Content_Wrap>
              <li>
                <img
                  src="/assets/images/promotion/Content1_2.png"
                  alt=""
                  style={{ position: 'absolute', right: 30.4, bottom: 0 }}
                />
                <img
                  src="/assets/images/promotion/Content1_1.png"
                  alt=""
                  style={{ position: 'absolute', bottom: 55, right: 6.25 }}
                />
                <Content_Text>
                  <Content_Sub_title>
                    <h3>
                      다양한 경공매 물건 검색 기능
                      <span style={{ fontFamily: 'Spoqa Han Sans Neo' }}>
                        ,
                      </span>
                      <br />
                      <UnderLine>지도 검색</UnderLine> 가능
                    </h3>
                  </Content_Sub_title>
                  <Content_Description>
                    <span>땅집고옥션에서 간편하게 경공매를 분석해보세요</span>
                    <span>지도로 검색해 직관적인 비교, 분석이 가능합니다.</span>
                  </Content_Description>
                </Content_Text>
              </li>
            </Content_Wrap>

            <Content_Wrap>
              <li>
                <img
                  src="/assets/images/promotion/Content2_3.png"
                  alt=""
                  style={{
                    position: 'absolute',
                    right: 30,
                    bottom: 0,
                    width: '260px',
                  }}
                />
                <img
                  src="/assets/images/promotion/Content2_2.png"
                  alt=""
                  style={{
                    position: 'absolute',
                    right: 19,
                    bottom: 51,
                    width: '160.5px',
                  }}
                />
                <img
                  src="/assets/images/promotion/Content2_1.png"
                  alt=""
                  style={{ position: 'absolute', right: 196.59, bottom: 99 }}
                />
                <Content_Text>
                  <Content_Sub_title>
                    <h3>
                      내 <UnderLine>알고리즘 분석</UnderLine>
                      <span style={{ fontFamily: 'Spoqa Han Sans Neo' }}>
                        ,
                      </span>
                    </h3>
                    <h3>추천 기능</h3>
                  </Content_Sub_title>
                  <Content_Description>
                    <span>
                      나만의 경매 성공공식,
                      <br />
                      AI 알고리즘을 만들어보세요.
                      <br />
                      빅데이터 기반으로 경공매
                      <br />
                      투자 의사 결정을 지원합니다.
                    </span>
                  </Content_Description>
                </Content_Text>
              </li>
            </Content_Wrap>

            <Content_Wrap>
              <li>
                <img
                  src="/assets/images/promotion/Content3_4.png"
                  alt=""
                  style={{
                    position: 'absolute',
                    right: 30.15,
                    bottom: 0,
                  }}
                />
                <img
                  src="/assets/images/promotion/Content3_1.png"
                  alt=""
                  style={{
                    position: 'absolute',
                    right: 168.9,
                    bottom: 111,
                    width: '131.1px',
                  }}
                />
                <img
                  src="/assets/images/promotion/Content3_2.png"
                  alt=""
                  style={{
                    position: 'absolute',
                    right: 124.9,
                    bottom: 18,
                    width: '131.1px',
                  }}
                />
                <img
                  src="/assets/images/promotion/Content3_3.png"
                  alt=""
                  style={{
                    position: 'absolute',
                    right: 33,
                    bottom: 65,
                    width: '131.1px',
                  }}
                />

                <Content_Text>
                  <Content_Sub_title>
                    <h3>
                      돈되는 테마주
                      <span style={{ fontFamily: 'Spoqa Han Sans Neo' }}>
                        ,
                      </span>
                    </h3>
                    <h3>
                      <UnderLine>퀀트 투자</UnderLine>
                    </h3>
                  </Content_Sub_title>
                  <Content_Description>
                    <span>AI경공매 퀀트 분석을 통해</span>
                    <span>12개의 퀀트 전략을 제공합니다.</span>
                    <span>시세보다 저평가된 물건부터</span>
                    <span>시세차익 물건까지 추천해드립니다.</span>
                  </Content_Description>
                </Content_Text>
              </li>
            </Content_Wrap>

            <Content_Wrap>
              <li>
                <img
                  src="/assets/images/promotion/Content4_2.png"
                  alt=""
                  style={{
                    position: 'absolute',
                    right: 30,
                    bottom: 0,
                    width: '260px',
                  }}
                />
                <img
                  src="/assets/images/promotion/Content4_1.png"
                  alt=""
                  style={{
                    position: 'absolute',
                    right: 20.21,
                    bottom: 92,
                    width: '108.79px',
                  }}
                />

                <Content_Text>
                  <Content_Sub_title>
                    <h3>약 40억건 데이터 학습 기반,</h3>
                    <h3>
                      <UnderLine>AI 분석 시스템</UnderLine>
                    </h3>
                  </Content_Sub_title>
                  <Content_Description>
                    <span>더이상 직감과 경험에 의존하지 마세요.</span>
                    <span>
                      땅집고옥션은 데이터로
                      <br />
                      투자 근거를 찾아드립니다!
                    </span>
                  </Content_Description>
                </Content_Text>
              </li>
            </Content_Wrap>

            <Text
              weight={500}
              size={14}
              color="#FFFFFF9C"
              style={{ textAlign: 'center' }}
            >
              *위 기능은 로그인한 회원 전용이며 일부 서비스 및 기능은 적용
              대상에서 제외될 수 있는 점 양해 부탁드립니다.
            </Text>
          </Column>
          <TextButton
            onClick={() => {
              window.open(`/guide`, '_blank');
            }}
          >{`땅집고옥션 이용가이드 보러가기  >`}</TextButton>
        </Inner>
      </Content>

      <Content backgroundColor="#F2F2F2" paddingTop={64} paddingBottom={64}>
        <Inner gap={40}>
          <Inner gap={8}>
            <Text Paperlogy weight={500} size={20}>
              회원가입하자마자
            </Text>
            <Text Paperlogy weight={700} size={24}>
              5일 무료체험하세요
            </Text>
          </Inner>
          <Inner gap={16}>
            <img
              src="/assets/images/promotion/free/coupon.png"
              alt="coupon"
              width="100%"
            />
            <Text weight={500} size={14} color="#2222229C">
              *회원가입 후 5일 무료체험 자동 적용됩니다.
            </Text>
          </Inner>
          {!isLogin() && (
            <TextButton onClick={() => navigate('/login')}>
              {`지금 무료체험 신청하기  >`}
            </TextButton>
          )}
        </Inner>
      </Content>

      <Footer_Container>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '24px',
            width: '518px',
            wordBreak: 'keep-all',
          }}
        >
          <Footer_Title>5일 무료체험 이벤트 유의사항</Footer_Title>
          <Footer_Description>
            ・ ‘5일 무료체험’ 이벤트 기간 : 상시
            <br />
            ・ 본 이벤트는 땅집고옥션 회원이라면 누구나 참여 가능합니다.
            <br />
            ・ 로그인 회원만 참여 가능하며 1개의 아이디 당 1회 5일간 사용
            가능합니다.
            <br />
            ・ 회원가입한 즉시 5일 무료체험이 시작됩니다.
            <br />
            ・ 이미 사용한 회원은 재신청 및 추가 기간 연장이 되지 않습니다.
            <br />
            ・ 5일 무료체험 일부 서비스는 제외되니 멤버십 페이지에서 확인 후
            체험하시길 바랍니다.
            <br />
            ・ 본 이벤트는 별도 고지 없이 변경 및 종료될 수 있습니다.
            <br />
          </Footer_Description>
        </div>
      </Footer_Container>
      <Footer />

      {openMenu && <Menu page="main" setOpenMenu={setOpenMenu} />}
    </Container>
  );
}

export default FreeTrial;

const Container = styled.div`
  background: #f7feff;
  user-select: none;
`;

const TopBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const TopBar_Inner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 16px 20px;
  align-items: center;

  img {
    height: auto;
    cursor: pointer;
  }
`;

const Content = styled.div<{
  backgroundColor?: string;
  paddingTop?: number;
  paddingBottom?: number;
  paddingRL?: number;
}>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding: ${({ paddingTop = 0, paddingBottom = 0, paddingRL = 16 }) =>
    `${paddingTop}px ${paddingRL}px ${paddingBottom}px`};
`;

const Column = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => `${gap}px`};
`;

const Row = styled(Column)`
  flex-direction: row;
`;

const Text = styled.span<{
  weight?: number;
  size?: number;
  height?: number;
  Paperlogy?: boolean;
  color?: string;
}>`
  font-family: ${({ Paperlogy }) =>
    Paperlogy ? 'Paperlogy' : 'Spoqa Han Sans Neo'};
  font-weight: ${({ weight }) => weight};
  font-size: ${({ size }) => `${size}px`};
  line-height: ${({ height = 145 }) => `${height}%`};
  color: ${({ color = '#222222' }) => color};
`;

const Inner = styled(Column)`
  justify-content: center;
  align-items: center;
`;

const Inner_row = styled(Inner)`
  flex-direction: row;
`;

const TitleBadge = styled.div`
  border-radius: 8px;
  padding: 12px 24px;
  background-color: #ffc23f;

  font-family: Paperlogy;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000000;
`;

const TitleDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;

  font-family: Spoqa Han Sans Neo;
  font-weight: 400;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #616161bf;

  p {
    padding: 0;
    margin: 0;
  }

  span {
    border-radius: 8px;
    padding: 4px 12px;
    background-color: #74e3ef;

    font-weight: 700;
    text-align: center;
    color: #2d2e32;
  }
`;

const Badge = styled.div`
  border-radius: 200px;
  padding: 12px 32px;
  background: linear-gradient(
    104.78deg,
    #e2fcff -7.27%,
    #a4edf5 27.93%,
    #74e3ef 66.81%,
    #59aaeb 107.96%
  );
  box-shadow:
    5px 5px 4px 0px #ffffff40 inset,
    3px 3px 4px 0px #ffffff26 inset,
    3px 3px 6px 0px #1f222426,
    5px 5px 20px 0px #1f222440;

  font-family: Paperlogy;
  font-weight: 800;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  color: linear-gradient(92.02deg, #2d2e32 0.15%, #1e1f22 97.93%);
`;

const Dot = styled.div<{ selected: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ selected }) => (selected ? '#3C3C3C' : '#D9D9D9')};
  cursor: pointer;
  transition: background-color 0.3s;
`;

const Highlight = styled.span`
  font-family: 'Paperlogy';
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  color: #68caff;
`;

const Content_Wrap = styled.ul`
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 0;
  margin: 0;

  li {
    position: relative;
    overflow: hidden;
    padding: 23px;
    height: 362px;
    background: #ffffff;
    border-radius: 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    max-width: 335px;
  }
`;

const Content_Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Content_Sub_title = styled.div`
  h3 {
    margin: 0;
    font-family: Paperlogy;
    font-weight: 700;
    font-size: 24px;
    line-height: 145%;
    letter-spacing: calc(24px * -0.02);
    text-align: center;
    span {
      font-family: Paperlogy;
    }
  }
`;

const Content_Description = styled.div`
  span {
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: calc(14px * -0.02);
    color: #616161;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const UnderLine = styled.span`
  background-image: linear-gradient(to top, #74e3ef 40%, transparent 40%);
  background-repeat: no-repeat;
  background-size: 110% 1em;
  background-position: 0 100%;
  font-family: Paperlogy;
`;

const TextButton = styled.button`
  display: flex;
  flex-direction: row;
  padding: 16px 0;
  gap: 8px;
  border-radius: 16px;
  background-color: #008aff;
  justify-content: center;
  align-items: center;
  width: 100%;
  cursor: pointer;
  border: none;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
`;

const Footer_Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  background: #1f1f1f;
`;

const Footer_Title = styled.div`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: calc(16px * -0.02);
  text-align: center;
  color: #ffffff;
`;

const Footer_Description = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: calc(12px * -0.02);
  color: #b0b0b0;
  word-break: keep-all;
`;

const Confirm_Button2 = styled.button<{ disabled?: boolean }>`
  border: none;
  padding-top: 20px;
  padding-bottom: 20px;
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 20px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: ${({ disabled }) => (disabled ? '#222222' : '#ffffff')};
  background: ${({ disabled }) => (disabled ? '#D6D6D7' : '#008AFF')};
  cursor: pointer;
  width: 100%;
  position: fixed;
  z-index: 5;
  bottom: 0;
`;
